import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ProviderType } from '../common/ObjectTypes';
import NoResults from '../common/NoResults';
import WebhookApiPushModal from './WebhookAPIPushModal';
import { textClasses, inputClasses } from '../common/tailwindClassnames';
import TechnologyCardGrid from '../common/TechnologyCardGrid';
import TechnologySearchInput from '../common/TechnologySearchInput';

// Re-exported: the grid's pagination window lives with the grid now, but this
// module is where it has always been imported from.
export { getPageNumbers } from '../common/TechnologyCardGrid';

type StepOneProps = {
  providerTypes: ProviderType[];
  reloadProviderTypes: boolean;
  loading: boolean;
  fetchError?: boolean;
  onSelectProviderType: (pt: ProviderType) => void;
  onSearchProviderType: (value: string) => void;
};

const NewRouteStepOne = ({
  providerTypes,
  reloadProviderTypes,
  loading,
  fetchError = false,
  onSelectProviderType,
  onSearchProviderType,
}: StepOneProps) => {
  const { t } = useTranslation();
  const [subStr, setSubStr] = useState('');
  const [selectedType, setSelectedType] = useState<string | null>(null);

  const handleCardSelect = (pt: ProviderType) => {
    onSelectProviderType(pt);
    setSelectedType(pt.id);
  };

  return (
    <div className="mt-8 w-full">
      <div className="mb-5 flex flex-col">
        <label
          className={
            textClasses.subheading + ' w-full text-center !text-[26px]'
          }
        >
          {t('What would you like to connect?')}
        </label>
        <TechnologySearchInput
          id="search"
          testId="NewRouteStepOne-search-input"
          value={subStr}
          placeholder={t('Search provider types')}
          ariaLabel={t('Search provider types')}
          onChange={(value) => {
            onSearchProviderType(value);
            setSubStr(value);
          }}
        />
      </div>

      <div className="mb-6">
        <TechnologyCardGrid
          items={providerTypes}
          loading={reloadProviderTypes || loading}
          selectedId={selectedType}
          onSelect={(item) => handleCardSelect(item as ProviderType)}
          testIdPrefix="NewRouteStepOne-provider"
          noResults={
            fetchError ? (
              <NoResults
                headerMsg={t('Could not load provider types')}
                labelMsg={t('Please try again or contact system admin.')}
              />
            ) : (
              <NoResults
                headerMsg={t('No Provider Types Found')}
                labelMsg={t('You may need to contact system admin.')}
              />
            )
          }
        />
      </div>

      {/* White, like the panels above it: the pale green read as a second
                page section rather than a footnote under the grid. */}
      <div className="mb-20 rounded-2xl bg-white px-8 py-8 transition-colors duration-300">
        <WebhookApiPushModal
          providerTypes={providerTypes}
          selectedType={selectedType}
          onSelectProviderType={onSelectProviderType}
          setSelectedType={setSelectedType}
        />
      </div>
    </div>
  );
};

export default NewRouteStepOne;
